import { debugInfo } from "@config"
import { getBillTemplate } from "./index"

const parseTreeJson = (tree = {}, permissions) => {
  const dfs = (node) => {
    // 有事件才处理
    if(isChecked(node)){
        // 配合设计器兼容 _alias
      const actionName = getActionName(node.onClick || node.onClick_Alias);
      const permission = permissions[node.onClick_Alias] || permissions[actionName]
      if (permission && permission.authFlag === false) {
        // node.caption = node.caption + '已禁用'
        node.visible = false
        console.log(`%c该组件 alias :${node.alias}, caption:${node.caption};已经被权限控制禁止显示,可以查看 permissions 字段 `, 'color: green')
        node.alias = node.alias + '-authFlag-false'//无权限情况禁止前端修改，修改别名
      }
    }
    node?.children?.forEach(item => dfs(item))
  }


  const isChecked = (node) => {
    return node.onClick || node.onClick_Alias;
  }
/**
 * 在一个Mobx表达式中抽取Action的Alias，如
 * actionExpr = "mobx://rootStore.actions.ABC.doAction", 则返回 ABC
 * actionExpr = "mobx://rootStore.actions.ABC()", 则返回ABC
 * @param {*} actionExpr
 * @returns 抽取的表达式中Action的名字
 */
const getActionName = (actionExpr) => {
  if (!actionExpr) return
  const match = actionExpr.match(/mobx:\/\/rootStore\.actions\.(.*)[\.\(](.*)/);
  return match ? match[1] : actionExpr;
}

  return dfs(tree)
}
const getAuthFlag = (auth, actions, key) => {
  // 一个action 可能有多个权限点，需要都找出来，并且要进行逐个检查对比。
  let filter = auth.filter(({ authId }) => actions[key].authId.split(',').includes(authId))
  let find = filter.find((item) => item.authFlag === false)
  let authFlag = find?.authFlag
  return { ...actions[key], authFlag }
}
export default (meta) => {
  if (!meta?.permissions?.auth) return meta
  let start = new Date().getTime()
  // const newPermissions = { fieldAuth: {}, auth: {} }
  let originAuth = meta.permissions.auth
  const actions = meta?.actions
  let newPermissions = {}
  console.groupCollapsed('%c【权限控制检查】', 'color: green; font-size:2em')
  Object.keys(actions)?.map(key =>
    (newPermissions[key] = actions[key]?.authId ? (getAuthFlag(originAuth, actions, key)) : ({ ...actions[key] }))
  )
  debugInfo('newPermissions', newPermissions)
  parseTreeJson(getBillTemplate(meta), newPermissions)
  meta.permissionsData = newPermissions
  debugInfo('filterPermissions耗时', new Date().getTime() - start)//@notranslate
  console.groupEnd();
  return meta
}
